import { Field } from "@components/common/Field";
import { Config, ConfigList } from "./AgencyManagement";

export const fieldsConfig: (
  t: (s: string) => string,
  configsList: ConfigList,
) => Field<Config>[] = (t, configsList) => [
  {
    key: "config",
    type: "select",
    label: t("admin.agency.agencyConfigSelection"),
    placeholder: t("admin.agency.agencyConfigSelect"),
    creation: {
      enabled: true,
      order: 1,
    },
    options: configsList,
  },
  {
    key: "alias",
    type: "text",
    label: t("admin.agency.agencyAlias"),
    creation: {
      enabled: true,
      order: 2,
    },
    options: configsList,
  },
];
